import "./i18n";

import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import { App } from "app";
import { store } from "app/store";
import { RootErrorBoundary } from "components";

// Dev-only console handle on a local BIM index (`window.bimIndex`). Imported
// lazily and dropped from production bundles by the `DEV` check — nothing loads
// until the first `bimIndex.open()`.
if (import.meta.env.DEV) {
    void import("features/bimIndex").then(({ installBimIndexConsoleApi }) => installBimIndexConsoleApi());
}

// Dev-only console handle on a local BIM index (`window.bimIndex`). Imported
// lazily and dropped from production bundles by the `DEV` check — nothing loads
// until the first `bimIndex.open()`.
if (import.meta.env.DEV) {
    void import("features/bimIndex").then(({ installBimIndexConsoleApi }) => installBimIndexConsoleApi());
}

const root = createRoot(document.body.children[0]);
root.render(
    <React.StrictMode>
        <RootErrorBoundary>
            <Provider store={store}>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </Provider>
        </RootErrorBoundary>
    </React.StrictMode>,
);
